<template lang="html">
  <div>
    <div>
      <h1>{{ active_id }}</h1>
      <p>
        <button v-for="config in configurations" :key="config" @click="active_id=config">{{ config }}</button>
      </p>

      <div v-if="active_id=='basic'" :key="active_id">
        <p>Using the show's defined dimensions</p>
        <SoundslidesPlayer :path="path" :use-show-dimensions="true" />
      </div>

      <div v-if="active_id=='always_show_controls'" :key="active_id">
        <p>Using the show's defined dimensions</p>
        <SoundslidesPlayer :path="path" :always_show_controls="true" :use-show-dimensions="true" />
      </div>

      <div v-if="active_id=='defined'" :key="active_id">
        <p>Defined width and height</p>
        <SoundslidesPlayer :path="path" :width="400" :height="300" />
        <SoundslidesPlayer :path="path" :width="500" :height="300" />
      </div>

      <div v-if="active_id=='fillcontainer_set'" :key="active_id">
        <div class="fillcontainer_class">
          <SoundslidesPlayer :path="path" />
        </div>
      </div>

      <div v-if="active_id=='fillcontainer_fluid'" :key="active_id">
        <div class="fillcontainer_fluid_class">
          <SoundslidesPlayer :path="path" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "Inline",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {
      active_id: "fillcontainer_set",
      configurations: [
        "basic",
        "defined",
        "fillcontainer_set",
        "fillcontainer_fluid",
        "always_show_controls"
      ]
    }
  },
  computed:{
    path(){
      var id = this.$route.params.id;
      if(id.length === 5){
        // Legacy hosting.
        return `https://s3.amazonaws.com/hosting.soundslides.com/${id}/`
      }else{
        return `https://s3.amazonaws.com/new.soundslides.hosting/${id}/`
      }
    }
  }
}
</script>

<style lang="css" scoped>
.fillcontainer_class{
  width: 700px;
  height: 533px;
}
.fillcontainer_fluid_class{
  width: 90%;
  height: 533px;
}
</style>
